import { useIsViewportSize } from './useIsViewportSize';

export const useIsMobile = (): boolean => {
	return useIsViewportSize('xs');
};
